interface LegalEntityDescription {
  readonly code: string;
  readonly label: string;
}

export const legalEntityToCode = new Map<number, LegalEntityDescription>([
  [1, { code: 'de', label: 'Germany' }],
  [9009999, { code: 'lu', label: 'Luxembourg' }],
  [401000, { code: 'it', label: 'Italy' }],
  [441000, { code: 'be', label: 'Belgium' }],
  [441001, { code: 'nl', label: 'Netherlands' }],
  [534000, { code: 'no', label: 'Norway' }],
  [950000, { code: 'ch', label: 'Switzerland' }],
  [790300, { code: 'gb', label: 'United Kingdom' }],
  [430000, { code: 'es', label: 'Spain' }],
  [660020, { code: 'dk', label: 'Denmark' }],
  [770000, { code: 'se', label: 'Sweden' }],
  [500000, { code: 'pl', label: 'Poland' }],
  [509997, { code: 'pl', label: 'Poland - DSC Poznan' }],
  [930000, { code: 'at', label: 'Austria' }],
  [910110, { code: 'fr', label: 'France' }],
  [510001, { code: 'fi', label: 'Finland' }],
  [2400000, { code: 'us', label: 'US North' }],
  [2400024, { code: 'us', label: 'US South' }],
  [24000241, { code: 'us', label: 'US FPO' }],
  [2450003, { code: 'ca', label: 'Canada' }],
  [2600000, { code: 'au', label: 'Australia' }],
  [7200000, { code: 'jp', label: 'Japan' }],
  [66005000, { code: 'mx', label: 'Mexico' }],
  [480002, { code: 'ru', label: 'Russia' }],
  [7010000, { code: 'th', label: 'Thailand' }],
  [7100011, { code: 'tw', label: 'Taiwan' }],
  [7500000, { code: 'hk', label: 'Hong Kong' }],
  [7300050, { code: 'sg', label: 'Singapore' }],
  [2700600, { code: 'in', label: 'India' }],
  [7900000, { code: 'cl', label: 'Chile' }],
  [7400002, { code: 'sg', label: 'HQ Asia pacific' }],
  [431000, { code: 'pt', label: 'Portugal' }],
  [75100, { code: 'de', label: 'Germany - DSC München' }],
  [77100, { code: 'de', label: 'DSC Hamburg Norderstedt' }],
  [600501, { code: 'hu', label: 'Hungary' }],
  [2810000, { code: 'ma', label: 'Morocco' }],
  [800555, { code: 'tr', label: 'Turkey' }],
  [800990, { code: 'tr', label: 'Turkey' }],
  [2610000, { code: 'nz', label: 'New Zealand' }],
  [464000, { code: 'cz', label: 'Czech Republic' }],
  [890050, { code: 'bg', label: 'Bulgaria' }],
  [6000000, { code: 'ci', label: 'Ivory Coast' }],
  [401300, { code: 'it', label: 'Italy - DSC Bozen' }],
  [473001, { code: 'ua', label: 'Ukraine' }],
  [480004, { code: 'ru', label: 'Russia' }],
  [509998, { code: 'pl', label: 'Poland' }],
  [750005, { code: 'ro', label: 'Romania' }],
  [860300, { code: 'bg', label: 'Bulgaria' }],
  [896000, { code: 'bg', label: 'Bulgaria - DSC Plovdiv' }],
  [930002, { code: 'at', label: 'Austria - DSC Salzburg' }],
  [2301030, { code: 'lt', label: 'Lithuania' }],
  [2900200, { code: 'ae', label: 'Dubai' }],
  [2901000, { code: 'ae', label: 'Dubai' }],
  [3200000, { code: 'my', label: 'Malaysia' }],
  [4721000, { code: 'kz', label: 'Kazakhstan' }],
  [4721010, { code: 'kz', label: 'Kazakhstan' }],
]);
